import React from 'react';

export function Plus() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="23px"
            height="23px"
            viewBox="0 0 23 23"
            version="1.1"
        >
            <g
                id="Symbols"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <g id="icon/plus" stroke="#00B673">
                    <g id="add-circle-1">
                        <g id="Outline_Icons_1_">
                            <g id="Outline_Icons">
                                <g id="Group">
                                    <circle id="Oval" cx="11.5" cy="11.5" r="11" />
                                    <path d="M11.5,5.5 L11.5,17.5" id="Shape" />
                                    <path d="M17.5,11.5 L5.5,11.5" id="Shape" />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}



// WEBPACK FOOTER //
// ./src/components/Login/Plus.js